'use strict';

function isFirefox() {
  return /firefox/i.test(navigator.userAgent);
}

module.exports = isFirefox;


/*****************
 ** WEBPACK FOOTER
 ** ../modules/utils/isFirefox.js
 ** module id = 41
 ** module chunks = 0
 **/